<div id="breadcrumbID" class="flex-display flex-wrap">
  <div *ngFor="let obj of crumbData ; last as islast" class="overlay-bread-crumb">
    <span tabindex="0">{{obj}}</span>
    <img *ngIf="!islast || currentParagraph != '' " src="../../../assets/icons/Arrow Right (Alt).svg" class="overlay-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right">
    <img *ngIf="(islast && arrowRightDown) || (obj == crumbData[crumbData.length - 1] && this.printPreview)" src="../../../assets/icons/Arrow RightDown (Alt).svg" class="overlay-bread-crumb-icon bread-crumb-Arrow" alt="Arrow Right Down">
  </div>
  <div class="overlay-bread-crumb print-content-hide" tabindex="0">
    {{currentParagraph}}
  </div>
</div>


